export var ExibraHeaders;
(function (ExibraHeaders) {
    ExibraHeaders["TenantId"] = "x-tenant-id";
})(ExibraHeaders || (ExibraHeaders = {}));
